import { TailSpin } from "assets";

export function PageLoading() {
  return (
    <div className="text-white flex justify-around items-center min-h-screen">
      <TailSpin className="h-10 w-10" />
    </div>
  );
}
